import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../../models/paging/paged-data';
import { Page } from '../../models/paging/page';
import { ServerData } from '../../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import * as moment from 'moment';

@Injectable()
export class ERSTRService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) {
  }

  public get(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get<any>('/api/engineerreport/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public getResults(page: Page, tabletUser_Id: string, applicationUser_Id: string, start_Date: string, end_Date: string, job_No: string, job_Type: number, company_Id: number, location_Id: number): Promise<PagedData<any>> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'submitted_At'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '&applicationUser_Id=' + applicationUser_Id;
      params += '&tabletUser_Id=' + tabletUser_Id;
      params += '&start_Date=' + moment(start_Date).format('YYYY-MM-DD');
      params += '&end_Date=' + moment(end_Date).format('YYYY-MM-DD');
      params += '&job_No=' + job_No;
      params += '&job_Type=' + job_Type;
      params += '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;

      this.http.get<ServerData>('/api/engineerreport/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;

        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });
  }

  public save(erstr): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post<any>('/api/engineerreport/post', erstr).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully created report');
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public update(erstr): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put<any>('/api/engineerreport/put', erstr).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully updated report');
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public delete(id): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.delete<any>('/api/engineerreport/delete?Id=' + id).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully deleted report');
      }, error => {
        console.log(error);
        reject();
      });
    });
  }

  public getAll(page: Page, tabletUser_Id: string, applicationUser_Id: string, start_Date: string, end_Date: string, job_No: string, job_Type: number, company_Id: number, location_Id: number): Promise<any> {
    const pagedData = new PagedData<any>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'submitted_At'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'desc'; }

      let params = '&applicationUser_Id=' + applicationUser_Id;
      params += '&tabletUser_Id=' + tabletUser_Id;
      params += '&start_Date=' + moment(start_Date).format('YYYY-MM-DD');
      params += '&end_Date=' + moment(end_Date).format('YYYY-MM-DD');
      params += '&job_No=' + job_No;
      params += '&job_Type=' + job_Type;
      params += '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;

      this.http.get<any>('/api/engineerreport/getAll?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.total;
        page.totalPages = page.totalElements / page.size;

        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(data.data);

      }, error => {
        reject();
      });
    });
  }
  public getExcel(page: Page, tabletUser_Id: string, applicationUser_Id: string, start_Date: string, end_Date: string, job_No: string, job_Type: number, company_Id: number, location_Id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      let params = '?applicationUser_Id=' + applicationUser_Id;
      params += '&tabletUser_Id=' + tabletUser_Id;
      params += '&start_Date=' + moment(start_Date).format('YYYY-MM-DD');
      params += '&end_Date=' + moment(end_Date).format('YYYY-MM-DD');
      params += '&job_No=' + job_No;
      params += '&job_Type=' + job_Type;
      params += '&company_Id=' + company_Id;
      params += '&location_Id=' + location_Id;

      this.http.get<any>('/api/engineerreport/getexcel' + params).subscribe(data => {
        let blob = this.converBase64toBlob(data, 'application/vnd.ms-excel');
        resolve(blob);
      }, error => {
        console.log(error);
        reject();
      });
    });
  }



  converBase64toBlob(content, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;
    let byteCharacters = window.atob(content); //method which converts base64 to binary
    let byteArrays = [
    ];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    let blob = new Blob(byteArrays, {
      type: contentType
    }); //statement which creates the blob
    return blob;
  }
}
